import { getBuildingPricingData } from "../../../helpers/building_pricing/buildingPricing.helper.js";
import { const_var, params } from "../../../redux/reducers/reducer.js";
import { batch } from "react-redux";
import * as utils from "../../../redux/reducers/utils.js";
import * as Constant from "../../../Constants/constant.js";
import { setPricingData } from "../../building_pricing/buildingPricing.action.js";
import { getPricingData, getPricingDataForLeanto } from "../../index.js";
import { customerListService, leadListService } from "../../../services/quote-order.service.js";
import { taxFromZip } from "../../../services/manufacture.services.js";
import { getInsulation } from "../../building_component/buildingComponent.action.js";
import { normalizeBuildingMaterials } from "../../../Intel/defaultBuilding/defaultbuilding.helper.js";
import { getBuildimgmaterial, getBuildingDoorWindowPricing, getDefaultBuildingList, getNewBuildingColor, getNewBuildingData } from "../../../services/building-service.js";
import { getSidingOrientationOptions } from "../../../helpers/building/building_material/buildingMaterial.helper.js";
import { getPricingDataforUtility } from "../../../helpers/building_pricing/buildingCalculation.helper.js";
import { checkLegsDataAccordingtoResponse } from "../../../helpers/building_component/legs_condition.helper.js";
import { editOldQuotes } from "../../../helpers/quote_order/quote.helper.js";
import { setZeroPriceOverhang } from "../../../helpers/extra_options_pricing/overhangPricing.js";
export const handleAccordionTab = (value, key, flag) => {
	return (dispatch) => {
		dispatch({
			type: "handleAccordionTab",
			value: value,
			key: key,
			flag: flag
		});
	};
};
export function buildingStyleChangeAccordingtoType(val, typen, shouldNotResetisLTBuildingFlag) {
	// console.log(val,typen,"val,typen")
	document.querySelector("body").classList.add("active-modal-loader");
	params.activeWall = "c_b_f_w";
	const_var.selectedDefaultIndex = val;
	const_var.wallSelection.centerBuildingWall = "c_b_f_w";
	const_var.wallSelection.leanToWall = "select";
	params.endStoragePositionZ = 0;
	const_var.selSidingOption = "metal";
	params.wallOrientation = "horizontal";
	const_var.selLoftVal = {
		center: 4,
		left: 4,
		right: 4,
		front: 4,
		back: 4
	};
	const_var.selSidingObj = {
		name: "metal",
		label: "Metal",
		price_type: "$",
		price_of: [],
		panel_price_from: ["vertical"],
		panel_orientation: ["horizontal", "vertical"],
		cost: 0
	};
	const_var.sidingOrientationOptions = getSidingOrientationOptions();
	if (val != undefined) {
		console.log(val, const_var.defaultBuildingArr, params.p_b_t, "const_var.defaultBuildingArr");
		let utilitySizes = const_var.defaultBuildingArr[val].size != undefined && const_var.defaultBuildingArr[val].size.split(",");
		if (const_var.defaultBuildingArr[val].name.includes("Utility Carports") && utilitySizes != undefined && utilitySizes.length > 1) {
			const_var.mutipleSizesBuilding = true;
		} else {
			const_var.mutipleSizesBuilding = false;
		}
	} else {
		const_var.mutipleSizesBuilding = false;
	}
	if (val == undefined && typen == undefined && const_var.b_o_J_1 != undefined) {
		if (const_var.b_o_J_1[params.p_b_t] != undefined && const_var.b_o_J_1[params.p_b_t].includes("Custom")) {
			const_var.checkmoreCustomizeFlag = !const_var.checkmoreCustomizeFlag;
		}
	}
	if (const_var.crmSetting.main_domain_url == "idealsteelbuildingsofca.com" && const_var.loginSession == false) {
		const_var.hide_price_calculation = const_var.stateData.hide_price_calculation;
	}
	if (val == undefined && typen == undefined) {
		document.querySelector("body").classList.remove("active-modal-loader");
		return (dispatch) => {
			dispatch({ type: "BUILDINGSTYLECHANGEBYTYPE" });
		};
	} else {
		const_var.CheckDoorForEdit = true;
		return (dispatch) => {
			if (typen.length > 1) {
				dispatch({ type: "BUILDINGSTYLECHANGEBYTYPE", value: val, othertype: typen });
			} else {
				dispatch(buildingStyleChange(val, typen, shouldNotResetisLTBuildingFlag));
			}
		};
	}
}

export function buildingStyleChange(val, buildingData, shouldNotResetisLTBuildingFlag) {
	const_var.isOverhang = {
		end: {
			isChecked: false,
			selected: "",
			size: 0.5
		},
		side: {
			isChecked: false,
			selected: "",
			size: 0.5
		},
		both: {
			isChecked: false,
			selected: "",
			size: 0.5
		}
	};
	const_var.newDoorsArray = [];
	const_var.entry_points = [];
	params.is_translusant = false;
	const_var.cupolas = [];
	const_var.CheckDefaultLoadForTween = true;
	const_var.CheckDoorForEdit = true;
	const_var.isShowbuildingtype = false;
	const_var.crmSetting.is_Edit = false;
	const_var.checkPickThisBuilding = false;
	const_var.isInsulaltionForOldQuotes = false;
	const_var.isTBSOldQuotesForVerticalRoof = false;
	const_var.selectedBuildingUniqId = val;
	const_var.isCheckColoredScrews = params.m_s_n == 167 || params.m_s_n == 184 ? true : false;
	params.oncenter_val_with_action = "";
	params.oncenter_val = 0;
	const_var.surcharge_amount_is_edit = false;
	const_var.is_loader = true;
	const_var.leanHasDoublelegshow = false;
	const_var.leanFHasDoublelegshow = false;
	const_var.leanRHasDoublelegshow = false;
	const_var.leanBHasDoublelegshow = false;
	const_var.onDragUtilityPriceUpdateLeft = false;
	const_var.onDragUtilityPriceUpdateRight = false;
	const_var.onDragUtilityPriceUpdateFront = false;
	const_var.onDragUtilityPriceUpdateBack = false;
	const_var.onDragUtilityPriceUpdateCenterBuilding = false;
	const_var.isWainscotManualPriceUpdate = false;

	return async (dispatch) => {
		dispatch({ type: "BUILDINGSTYLECHANGE", value: val, shouldNotResetisLTBuildingFlag: shouldNotResetisLTBuildingFlag });
		let apiData = "";
		if (const_var.b_o_J_1[params.p_b_t].includes("Free Standing Lean-to")) {
			if (const_var.b_o_J_1[params.p_b_t].includes("Free Standing Lean-to")) {
				params.p_r_p = 2;
				params.b_r_p = "212";
			}
			let chkFixedWidth = false;
			chkFixedWidth = const_var.c_m_a[params.p_b_t] ? (const_var.c_m_a[params.p_b_t].fixed_new_leg_width ? (const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length > 0 ? true : false) : false) : false;
			apiData = {
				width: params.p_b_t == "2" ? params.p_w + 24 : params.p_w,
				height: params.p_h,
				single_slope_height:
					const_var.c_m_a[params.p_b_t] != undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width != undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length > 0
						? Math.floor(params.p_h - (params.p_w * params.p_r_p) / 12)
						: Math.round(params.p_h - (params.p_w * params.p_r_p) / 12),
				length: params.p_d,
				map_id: const_var.Map_Id[params.p_b_t],
				roof_id: params.p_r_s,
				lean_to_height: 0,
				utility_length: params.p_u_c == true ? params.p_u_t : 0,
				is_smaller_frame_width: chkFixedWidth
			};
		} else {
			apiData = {
				width: params.p_b_t == "2" ? params.p_w + 24 : params.p_w,
				height: params.p_h,
				length: params.p_d,
				map_id: const_var.Map_Id[params.p_b_t],
				roof_id: params.p_r_s,
				lean_to_height: 0,
				utility_length: params.p_u_c == true ? params.p_u_t : 0,
				front_utility_length: params.cB_addStorage_check_front ? Math.round(params.cB_addStorage_front) : 0
			};
		}
		if (const_var.b_o_J_1[params.p_b_t] == "Custom Buildings") {
			apiData.is_lean_to_price = true;
		}
		if (params.p_r_p != undefined) {
			apiData.pitch_type = `${params.p_r_p}_12`;
		}
		if (const_var.selSidingObj && const_var.selSidingObj.name != "metal" && const_var.selSidingObj.price_type != "%") {
			apiData.side_end_name = const_var.selSidingObj.name;
		}
		if (const_var.otherBuildingRoofPitch != "") {
			apiData.pitch_type = `${const_var.otherBuildingRoofPitch}_12`;
		}
		if (params.m_s_n == 122 && const_var.selSidingObj && const_var.selSidingObj.name?.includes("board_and_batten")) {
			apiData.send_default_data = true;
		}
		getBuildingDoorWindowPricing({
			manufacturerId: "122",
			buildingId: const_var.c_m_a[params.p_b_t].uniqueBuildingId,
			priceBookId: const_var.c_m_a[params.p_b_t].uniquePriceBookId,
			roofId: String(params.p_r_s),
			frameGauge: 12
		})
			.then((doorWindowPriceResponse) => {
				const_var.componentData = doorWindowPriceResponse.data;
				dispatch({
					type: "makeComponentAction",
					value: doorWindowPriceResponse.data
				});
			})
			.catch((error) => {
				console.error("getBuildingDoorWindowPricing failed", error);
			});

		const {response} = await getBuildingPricingData(apiData);
		const_var.c_m_a[params.p_b_t]["wainscot_details"] = response?.data?.data?.wainscot ?? [];
		const_var.c_m_a[params.p_b_t]["drawings"] = response?.data?.data?.drawings?.map((drawing, index) => ({ ...drawing, is_default: drawing.name.includes("None") ? "yes" : "no" }));
		const promises = [];

		if (const_var.stateData?.fetch_price_for?.surcharge && const_var.surcharge_amount_is_edit != true) {
			const_var.UpdatedPriceData.surcharge_amount = undefined;
		}
		if (params.m_s_n == 122 && const_var.selSidingObj != {} && const_var.selSidingObj.name.includes("board_and_batten") && response?.data?.data) {
			setZeroPriceOverhang(response.data.data);
		}
		if (const_var.oldFreeStandingData !== undefined && const_var.b_o_J_1[params.p_b_t].includes("Free Standing Lean-to")) {
			editOldQuotes(const_var.oldFreeStandingData, "edit", response);
		}
		const_var.isUpdate4ftLegLogic = /* true */ params.m_s_n == 3 ? true : false;
		const_var.ConditionArr[params.p_b_t][params.p_r_s] = response.data.data?.building_structure?.[0]?.conditions["Leg_Height_condition"];
		checkLegsDataAccordingtoResponse(response.data.data?.building_structure?.[0]?.conditions["Leg_Height_condition"], "dimension");
		const_var.UpdatedPriceData.roof_style_price_changed = true;
		const_var.UpdatedPriceData.height_price_changed = true;
		const_var.UpdatedPriceData.roof_pitch_price_changed = true;
		const_var.engineer_drawings_price_changed = true;
		const_var.installationsurfaceChange = true;
		if (params.m_s_n == 11 || params.m_s_n == 54 || params.m_s_n == 147 || params.m_s_n == 160) {
			const_var.isCheckGroundCertificate = true;
		}
		if (
			params.p_i_o != 0 &&
			response.data.data != undefined &&
			response.data.data.central_insulation != undefined &&
			const_var.isInsulaltionForOldQuotes == false &&
			const_var.crmSetting.is_Edit == true &&
			response.data.data.central_insulation.filter((obj) => obj.insulation_id == params.p_i_o).length == 0
		) {
			params.p_i_o = response.data.data.insulation[0].insulation_id; //0
			params.selectedInsulationId = response.data.data.central_insulation[0].insulation_id;
			params.insulation.center.isCheked = false;
			params.insulation.center.insulationId = 0;
			params.insulation.center.roofOnly = false;
			params.insulation.center.fullBuilding = false;
			params.insulation.center.custom = false;
			params.insulation.center.showInsulationOptions = false;
			params.insulation.center.isDisableFullInsulation = false;
			params.l_t_p = JSON.parse(JSON.stringify(Constant.defaultInsulationValues));
		} else {
			params.p_c_i = false;
			params.p_r_o = false;
			params.p_f_i = false;
			params.p_i_o = 0;
			params.l_t_p = JSON.parse(JSON.stringify(Constant.defaultInsulationValues));
			const_var.insulationPriceJson = [];
			const_var.insulationArrayForLeantoLeft = [];
			const_var.insulationArrayForLeantoFront = [];
			const_var.insulationArrayForLeantoBack = [];
			const_var.insulationArrayForLeantoRight = [];
		}

		dispatch({
			type: "resetAlltheEditValue",
			value: val
		});
		const_var.holdPricingResponse = response.data?.data;
		utils.prepareLoftDropdown();
		dispatch(setPricingData(response.data, "h"));
		if (const_var.defaultBuildingArr[val]?.leanto == "both") {
			const_var.checkforLeanto = true;
			promises.push(dispatch(getPricingDataForLeanto(true, "addLeftLean")));
			promises.push(dispatch(getPricingDataForLeanto(true, "addRightLean")));
			const_var.checkforLeanto = true;
		}
		if (params.add_left_lean == true) {
			const_var.checkforLeanto = true;
			promises.push(dispatch(getPricingDataForLeanto(true, "addLeftLean")));
		}
		if (params.add_right_lean == true) {
			const_var.checkforLeanto = true;
			promises.push(dispatch(getPricingDataForLeanto(true, "addRightLean")));
		}
		if (params.add_front_lean == true) {
			const_var.checkforLeanto = true;
			promises.push(dispatch(getPricingDataForLeanto(true, "addFrontLean")));
		}
		if (params.add_back_lean == true) {
			const_var.checkforLeanto = true;
			promises.push(dispatch(getPricingDataForLeanto(true, "addBackLean")));
		}

		Promise.allSettled(promises).then(() => dispatch({ type: "STOP_LOADER" }));

		const_var.UpdatedPriceData.connection_fee_end_changed = true;
		const_var.UpdatedPriceData.connection_fee_side_changed = true;
		const_var.UpdatedPriceData.left_front_wrap_connection_fee_changed = true;
		const_var.UpdatedPriceData.right_front_wrap_connection_fee_changed = true;
		const_var.UpdatedPriceData.right_back_wrap_connection_fee_changed = true;
		const_var.UpdatedPriceData.left_back_wrap_connection_fee_changed = true;
		const_var.UpdatedPriceData.common_length_changed = true;
		const_var.UpdatedPriceData.common_left_lean_length_changed = true;
		const_var.UpdatedPriceData.common_right_lean_length_changed = true;
		const_var.UpdatedPriceData.common_front_lean_length_changed = true;
		const_var.UpdatedPriceData.common_back_lean_length_changed = true;

		if (const_var.crmSetting.selected_sub_module == 1 && const_var.crmSetting.form_action == "create" && const_var.crmSetting.login_user_id != undefined) {
			let searchParam = {
				user_id: const_var.crmSetting.login_user_id,
				api_token: const_var.crmSetting.api_token,
				search_text: "",
				limit: 100,
				offset: 0,
				module: const_var.crmSetting.sub_module,
				module_id: const_var.crmSetting.sub_module_id
			};
			const apiCall = const_var.crmSetting.is_module_name === "quote" ? leadListService : customerListService;
			return apiCall(const_var.crmSetting.login_user_id, "", 100).then((response) => {
				if (response.data.data.length > 0) {
					if (response.data.data[0].address != undefined && response.data.data[0].address.length > 0) {
						let priceData = response.data.data[0].address != undefined ? response.data.data[0].address.filter((address) => address.is_billing == 1) : undefined;
						let priceData1 = response.data.data[0].address != undefined ? response.data.data[0].address.filter((address) => address.is_installation == 1) : undefined;
						response.data.data[0].address.map((slide, index) => {
							if (priceData != undefined && priceData <= 0) {
								if (slide.is_default == 1) {
									response.data.data[0].address[index].is_billing = 1;
								}
							}
							if (priceData1 != undefined && priceData1 <= 0) {
								if (slide.is_default == 1) {
									response.data.data[0].address[index].is_installation = 1;
								}
							}
						});
					}
					if (response.data.states != undefined) {
						const_var.leadSourceStateData = response.data.states;
					}

					if (
						response.data.data[0].address.length > 0 &&
						response.data.data[0].address != undefined &&
						response.data.data[0].address[0].zipcode != "" &&
						response.data.data[0].address[0].zipcode != null &&
						response.data.data[0].address[0].zipcode != undefined &&
						const_var.tax.percentage == 0
					) {
						let zipData = { zip_code: response.data.data[0].address[0].zipcode };

						return taxFromZip(zipData).then(function (response1) {
							if (response1.data.status == true) {
								if (const_var.MoreTaxinputs.length > 0) {
									const_var.MoreTaxinputs = [];
								}
								const_var.holdTaxArrResp = [];
								response.data.data[0].taxPersentage = response1.data.data[0];
								if (response1.data.tax_data != undefined && response1.data.tax_data != "") {
									let i = 0;
									Object.entries(response1.data.tax_data)
										.sort()
										.map(([value, key]) => {
											if (key != 0) {
												if (i == 0) {
													response.data.data[0].taxPersentage = key;
													const_var.tax.name = const_var.taxTypeName[value];
												} else {
													const_var.MoreTaxinputs.push({ amount: 0, name: const_var.taxTypeName[value], percentage: key, type: "per" });
												}
												const_var.holdTaxArrResp?.push({ amount: 0, name: const_var.taxTypeName[value], percentage: key, type: "per", tax_value: key });
												i++;
											}
										});

									if (const_var?.post_data?.building?.tax) {
										const_var.post_data.building.tax = const_var.holdTaxArrResp;
									}
									if (const_var.holdTaxArrResp.length == 0) {
										const_var.post_data.building.tax = [];
										const_var.MoreTaxinputs = [];
									}
								}
							} else {
								response.data.data[0].taxPersentage = 0;
							}
							dispatch({
								type: "handleCustomerData",
								event: "",
								row: response.data.data[0],
								isSelect: "",
								rowIndex: "",
								eventType: ""
							});
						});
					} else {
						dispatch({
							type: "handleCustomerData",
							event: "",
							row: response.data.data[0],
							isSelect: "",
							rowIndex: "",
							eventType: ""
						});
					}
				}
			});
		}
	};
}

export const createGetBuildingData = (deps, actions) => {
	const { params, const_var, cuComponent, setPdfFile, getSelectedTabstate, changeBuildingData, buildingStyleChange, isOpenWelcomeModal } = deps;
	const { discountApi } = actions;

	function getBuildingData(data) {
		const_var.showReportLoading = true;
		return async (dispatch) => {
			const_var.b_t_x_P_g = [];
			const_var.fromGetBuildingData = true;
			const_var.editstateColorAcordingAPI[params.p_s_n] = {};
			const_var.CheckSnowLoadValue = 35;
			params.isSnowLoad = false;
			if (const_var.stateColorAcordingAPI[params.p_s_n] == undefined) {
				const_var.stateColorAcordingAPI[params.p_s_n] = {};
			}
			const_var.noCursorClass = false;
			const_var.garageDoorColor = [];
			const_var.leanGetDataLeft = const_var.leanGetDataRight = const_var.leanGetDataFront = const_var.leanGetDataBack = "";
			const_var.editstateColorAcordingAPI[params.p_s_n] = {};
			const_var.stateChangeflag = params.p_s_n;
			const_var.stateMenuChangeflag = params.m_s_n;
			const_var.mapIdforLean = "";
			const_var.defaultBuildingArr = [];
			if (
				const_var.stateManufacturerAcordingAPI[params.p_s_n].manufacturer_list &&
				Array.isArray(const_var.stateManufacturerAcordingAPI[params.p_s_n].manufacturer_list) &&
				const_var.stateManufacturerAcordingAPI[params.p_s_n].manufacturer_list.length > 1
			) {
				const_var.bjDData = [];
			}
			if (
				const_var.stateManufacturerAcordingAPI &&
				(Object.keys(const_var.stateManufacturerAcordingAPI).length == 1 || (Object.keys(const_var.stateManufacturerAcordingAPI).length > 1 && const_var.crmSetting.is_zipcode_screen))
			) {
				const_var.bjDData = [];
			}
			const_var.additionalFeaturesArray = [];
			const_var.extraItemsFeaturesCost = [];
			const_var.extraItemsFeaturesQuantityCost = [];
			const_var.ExtraItemsFeaturesQuantityArray = [];
			const_var.ExtraItemsFeaturesDropdownQuantityArray = [];
			const_var.surcharge_amount_is_edit = false;
			cuComponent.removeAlltheComponent();
			const_var.is_loader = false;
			params.selectedState = params.p_s_n;
			let prevManufacture = params.m_s_n;
			let manufacturename = params.m_s_n != "" && const_var.stateManufacturerAcordingAPIDiscount["manuName"] != undefined ? const_var.stateManufacturerAcordingAPIDiscount["manuName"][params.m_s_n] : "";

			params.selectedManufacture = manufacturename;
			params.selectedManufactureId = params.m_s_n;

			var apiDataBuilding = { manufacturer_id: params.m_s_n, state_id: params.p_s_n };
			var apiDiscountData = {
				api_token: const_var.crmSetting.api_token,
				manufacturer_id: "all",
				"3D": true
			};
			if (
				((const_var.crmSetting.is_CRM == undefined || const_var.crmSetting.is_CRM == false) && const_var.loginSession == true) ||
				const_var.isKLinkEnable == true ||
				(const_var.isPublicEdit == true && const_var.crmSetting.is_Edit == true)
			) {
				apiDiscountData = {
					api_token: const_var.crmSetting.api_token,
					manufacturer_id: "all",
					"3D": true,
					company_id: params.company_id
				};
				dispatch(discountApi(apiDiscountData, "all"));
			}
			let DomainURI = window.location.href;
			if (
				DomainURI?.includes("3d-public") &&
				(const_var.editAPIDataByResponse?.data?.request_data?.sensei_sales_id ||
					const_var.editAPIDataByResponse?.data?.request_data?.sensei_sales_id == "" ||
					const_var.editAPIDataByResponse?.data?.request_data?.company_id)
			) {
				apiDiscountData.api_token = const_var.requestApiToken;
			}
			await dispatch(discountApi(apiDiscountData, "all", params.m_s_n));
			const response = { data: {} };
			if (response != undefined) {
				/* ---------------- NEW MICROSERVICE APIS ---------------- */
				const [newBuildingData, newBuildingColor, newBuildingMaterial] = await Promise.all([
					getNewBuildingData({
						manufacturerId: "122",
						zipCode: "30002"
					}),
					getNewBuildingColor({
						manufacturerId: "122"
					}),
					getBuildimgmaterial({
						manufacturerId: "122"
					})
				]);
				const buildingApiResponse = newBuildingData;

				const transformedData = {
					building: buildingApiResponse?.data?.building,

					default_building: buildingApiResponse?.data?.default_buildings?.map((item, index) => ({
						...item.config_data,
						id: index + 1,
						other_building_id: String(item.config_data?.building_id),
						image_url: item.image_url,
						utility: 0
					}))
				};
				const_var.isForStandardBuilding = false;
				cuComponent.removeAlltheComponent();

				dispatch({
					type: "DISABLE_DOOR_WINDOW_EDIT_ICONS"
				});
				const normalizedMaterials = normalizeBuildingMaterials(newBuildingMaterial?.data);
				response.data.newBuildingData = transformedData;
				response.data.newBuildingColor = newBuildingColor.data;
				response.data.newBuildingMaterial = normalizedMaterials;
				// FORCEFULLY CHANGING WALL NAME FOR GABLE LEAN TO DOORS (since backend is not sending us correct wall names)
				for (let i = 0; i <= response?.data?.newBuildingData?.default_building?.length - 1; i++) {
					if (response.data.newBuildingData?.default_building[i].default_doors?.length > 0) {
						const isGableLean = (leanType) => {
							return !!response.data.newBuildingData?.default_building[i].leanto_data[`gable_${leanType}`]?.size;
						};
						for (let j = 0; j <= response.data.newBuildingData?.default_building[i].default_doors.length - 1; j++) {
							const LEAN_NAME = {
								B: "back",
								F: "front",
								L: "left",
								R: "right"
							};
							if (isGableLean(LEAN_NAME[response.data.newBuildingData?.default_building[i].default_doors[j].wall[0]])) {
								response.data.newBuildingData.default_building[i].default_doors[j].wall = `G_${response.data.newBuildingData?.default_building[i].default_doors[j].wall}`;
							}
						}
					}
				}
				dispatch(changeBuildingData(response.data, newBuildingData, newBuildingColor.data, normalizedMaterials));
				const_var.showProcessLoaderchkEdit = false;
				dispatch(getSelectedTabstate("buildingtypetab"));
				dispatch(buildingStyleChange(1, response.data.newBuildingData));
				dispatch(isOpenWelcomeModal(true, ""));
				setTimeout(() => {
					const checkaddmodalclass = document.querySelector(".welcomeparent");
					if (checkaddmodalclass != undefined) {
						document.querySelector(".welcomeparent").classList.add("showwelcomeparent");
					}
				}, 500);
				const_var.showReportLoading = false;
				const_var.isGlobalZipUpdate = false;
			}
			if (const_var.loginSession == true) {
				setPdfFile(dispatch);
			}
		};
	}
	return getBuildingData;
};
export const changeBuildingRoof = ({ event, value, skipCheck }) => {
	let checlLeavRoofPitch = { left: params.b_l_t_r_p, right: params.b_l_t_r_pR, front: params.b_l_t_r_pF, back: params.b_l_t_r_pB };
	return (dispatch) => {
		if (!skipCheck) {
			params.preAction = { event, value, type: "changeBuildingRoof" };
			dispatch({
				type: "checkChangeBuildingRoof",
				event: event,
				value: value
			});
		}
		const_var.UpdatedPriceData.insulation_price_changed = true;
		if (!const_var.isShowAlert || skipCheck) {
			dispatch({
				type: "changeBuildingRoof",
				event: event,
				value: value
			});
			if (!const_var.isShowAlert) {
				getInsulation(event, value);
			}
			const_var.UpdatedPriceData.insulation_price_changed = true;
			if (
				const_var.c_f_a_per[params.p_e_i] &&
				const_var.c_f_a_per[params.p_e_i] != 0 &&
				const_var.c_f_aCer[params.p_e_i] != undefined &&
				const_var.c_f_aCer[params.p_e_i].percentage_of != undefined &&
				const_var.c_f_aCer[params.p_e_i].percentage_of &&
				const_var.c_f_aCer[params.p_e_i].percentage_of_cost > 0
			) {
				const_var.UpdatedPriceData.certificate_price_changed = true;
			}
			if (params.cB_addStorage_check_left == true) {
				dispatch(getPricingDataforUtility(event, "left_combo", params.cB_addStorage_left));
			}
			if (params.cB_addStorage_check_right == true) {
				dispatch(getPricingDataforUtility(event, "right_combo", params.cB_addStorage_right));
			}
			var LeantoName = "";
			if ((params.add_right_lean == true && value == "right") || (params.add_right_lean && checlLeavRoofPitch.right != params.b_l_t_r_pR)) {
				dispatch(getPricingDataForLeanto(true, "addRightLean", "", false, "", "roofInsulation"));
			}
			if ((params.add_left_lean == true && value == "left") || (params.add_left_lean && checlLeavRoofPitch.left != params.b_l_t_r_p)) {
				dispatch(getPricingDataForLeanto(true, "addLeftLean", "", false, "", "roofInsulation"));
			}
			if ((params.add_front_lean == true && value == "front") || (params.add_front_lean && checlLeavRoofPitch.front != params.b_l_t_r_pF)) {
				dispatch(getPricingDataForLeanto(true, "addFrontLean", "", false, "", "roofInsulation"));
			}
			if ((params.add_back_lean == true && value == "back") || (params.add_back_lean && checlLeavRoofPitch.back != params.b_l_t_r_pB)) {
				dispatch(getPricingDataForLeanto(true, "addBackLean", "", false, "", "roofInsulation"));
			}
			const_var.UpdatedPriceData.insulation_price_changed = true;
			const_var.UpdatedPriceData.left_lean_insulation_price_changed = true;
			const_var.UpdatedPriceData.right_lean_insulation_price_changed = true;
			const_var.UpdatedPriceData.front_lean_insulation_price_changed = true;
			const_var.UpdatedPriceData.back_lean_insulation_price_changed = true;
			params.preAction = {};
		}
	};
};
export const onRoofStyleChange = (newRoofStyleCode) => {
	return (dispatch) => {
		const_var.isRoofPitchChangedManually = true;
		const_var.UpdatedPriceData.roof_pitch_price_changed = true;
		const selectedRoofPitch = params.b_r_p;

		if (const_var.a_p_d_a.roof_pitch) {
			let updatedRoofPitchObj = {};
			const_var.a_p_d_a.roof_pitch.forEach((rP) => {
				if (rP.roof_ids != undefined && (rP.roof_ids.includes(newRoofStyleCode) || rP.roof_ids.includes("0"))) {
					updatedRoofPitchObj[rP.roof_pitch] = rP;
				}
			});
			if (Object.keys(updatedRoofPitchObj).length > 0) {
				const_var.BuildingRoofPitchObj = updatedRoofPitchObj;
			}
		}

		const listOfAvaialbleRoofPitch = Object.values(const_var.BuildingRoofPitchObj)?.filter((roofPitch) => roofPitch.roof_ids.includes(newRoofStyleCode) || roofPitch.roof_ids.includes("0"));
		const selectedRoofPitchExist = listOfAvaialbleRoofPitch.some((roofPitch) => roofPitch.roof_pitch.replace("/", "") == selectedRoofPitch);
		const defaultRoofPitch = listOfAvaialbleRoofPitch.find((roofPitch) => roofPitch.is_default == "yes");
		const roofPitchValue = listOfAvaialbleRoofPitch[0]?.roof_pitch?.replace("/", "");
		const value = defaultRoofPitch ? defaultRoofPitch.roof_pitch.replace("/", "") : roofPitchValue;

		let should = false;
		if (params.m_s_n == 115) {
			if (selectedRoofPitchExist) {
				if (params.p_r_s == 1 || params.p_r_s == 2 || (params.p_r_s == 2 && params.p_w >= 25)) {
					should = true;
				}
			} else {
				should = true;
			}
		} else {
			should = true;
		}

		if (should) {
			dispatch(changeBuildingRoof({ event: value, value: "center" }));
			if (params.add_left_lean) {
				let leanAvaialbleRoofPitch = Object.values(const_var.leanto_roof_pitch_obj)?.filter((roofPitch) => roofPitch.roof_ids.includes(newRoofStyleCode) || roofPitch.roof_ids.includes("0"));
				const leanSelectedRoofPitchExist = leanAvaialbleRoofPitch.some((roofPitch) => roofPitch.roof_pitch.replace("/", "") == params.b_l_t_r_p);

				const leanDefaultRoofPitch = leanAvaialbleRoofPitch.find((roofPitch) => roofPitch.is_default == "yes");
				const lLeanRoofPitchValue = leanAvaialbleRoofPitch[0]?.roof_pitch?.split("/")[0];
				const leanValue = leanDefaultRoofPitch ? leanDefaultRoofPitch.roof_pitch.split("/")[0] : lLeanRoofPitchValue;
				// const leftLeanValue = leanDefaultRoofPitch ? leanDefaultRoofPitch.roof_pitch.replace("/", "") : lLeanRoofPitchValue;
				dispatch(changeBuildingRoof({ event: leanValue, value: "left" }));
			}
			if (params.add_right_lean) {
				let leanAvaialbleRoofPitch = Object.values(const_var.leanto_roof_pitch_obj)?.filter((roofPitch) => roofPitch.roof_ids.includes(newRoofStyleCode) || roofPitch.roof_ids.includes("0"));
				const leanSelectedRoofPitchExist = leanAvaialbleRoofPitch.some((roofPitch) => roofPitch.roof_pitch.replace("/", "") == params.b_l_t_r_pR);

				const leanDefaultRoofPitch = leanAvaialbleRoofPitch.find((roofPitch) => roofPitch.is_default == "yes");
				const lLeanRoofPitchValue = leanAvaialbleRoofPitch[0]?.roof_pitch?.split("/")[0];
				const leanValue = leanDefaultRoofPitch ? leanDefaultRoofPitch.roof_pitch.split("/")[0] : lLeanRoofPitchValue;

				dispatch(changeBuildingRoof({ event: leanValue, value: "right" }));
			}
			if (params.add_front_lean) {
				let leanAvaialbleRoofPitch = Object.values(const_var.leanto_roof_pitch_obj)?.filter((roofPitch) => roofPitch.roof_ids.includes(newRoofStyleCode) || roofPitch.roof_ids.includes("0"));
				const leanSelectedRoofPitchExist = leanAvaialbleRoofPitch.some((roofPitch) => roofPitch.roof_pitch.replace("/", "") == params.b_l_t_r_pF);

				const leanDefaultRoofPitch = leanAvaialbleRoofPitch.find((roofPitch) => roofPitch.is_default == "yes");
				const lLeanRoofPitchValue = leanAvaialbleRoofPitch[0]?.roof_pitch?.split("/")[0];
				const leanValue = leanDefaultRoofPitch ? leanDefaultRoofPitch.roof_pitch.split("/")[0] : lLeanRoofPitchValue;

				dispatch(changeBuildingRoof({ event: leanValue, value: "front" }));
			}
			if (params.add_back_lean) {
				let leanAvaialbleRoofPitch = Object.values(const_var.leanto_roof_pitch_obj)?.filter((roofPitch) => roofPitch.roof_ids.includes(newRoofStyleCode) || roofPitch.roof_ids.includes("0"));
				const leanSelectedRoofPitchExist = leanAvaialbleRoofPitch.some((roofPitch) => roofPitch.roof_pitch.replace("/", "") == params.b_l_t_r_pB);

				const leanDefaultRoofPitch = leanAvaialbleRoofPitch.find((roofPitch) => roofPitch.is_default == "yes");
				const lLeanRoofPitchValue = leanAvaialbleRoofPitch[0]?.roof_pitch?.split("/")[0];
				const leanValue = leanDefaultRoofPitch ? leanDefaultRoofPitch.roof_pitch.split("/")[0] : lLeanRoofPitchValue;

				dispatch(changeBuildingRoof({ event: leanValue, value: "back" }));
			}
		}
	};
};
export function changeBuildingDimension({ val, str, checkLean, checkCustomDimension, secondParam, leftFront, rightFront, leftBack, rightBack, skipCheck, valueToSet, from, noApiCall = false }) {
	if (str == "h") {
		if (const_var.crmSetting.main_domain_url == "idealsteelbuildingsofca.com" && const_var.loginSession == false) {
			const_var.hide_price_calculation = const_var.stateData.hide_price_calculation;
			utils.onWidthHeightChange(params.p_w, val);
		}
	}
	if (str == "w") {
		if (const_var.crmSetting.main_domain_url == "idealsteelbuildingsofca.com" && const_var.loginSession == false) {
			const_var.hide_price_calculation = const_var.stateData.hide_price_calculation;
			utils.onWidthHeightChange(val, params.p_h);
		}
	}
	if (str == "h") {
		const_var.diffHeight = params.p_h;
	}
	return (dispatch) => {
		if (!skipCheck) {
			params.preAction = { val, str, checkLean, checkCustomDimension, secondParam, leftFront, rightFront, leftBack, rightBack, skipCheck, type: "CHANGEDIMENSION" };

			if (checkLean == undefined) {
				dispatch({
					type: "checkCHANGEDIMENSION",
					value: val,
					str: str,
					secondParam: secondParam == undefined ? undefined : secondParam,
					checkCustomDimension: checkCustomDimension == undefined ? undefined : checkCustomDimension
				});
			} else {
				dispatch({
					type: "checkCHANGEDIMENSION",
					value: val,
					str: str
				});
			}
		}
		if (!const_var.isShowAlert || skipCheck) {
			if (checkLean == undefined) {
				utils.update26GAUpgradePrice();
				batch(() => {
					dispatch({
						type: "CHANGEDIMENSION",
						value: val,
						str: str,
						secondParam: secondParam == undefined ? undefined : secondParam,
						checkCustomDimension: checkCustomDimension == undefined ? undefined : checkCustomDimension,
						from: from
					});

					if (const_var.isShowAlert == false) {
						if ((str == "w" || str == "l") && params.singleSlope == true) {
							if (
								const_var.c_m_a[params.p_b_t] != undefined &&
								const_var.c_m_a[params.p_b_t].fixed_new_leg_width != undefined &&
								const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length > 0 &&
								const_var.c_m_a[params.p_b_t].fixed_new_leg_width[0][params.p_w]
							) {
								let chkFixedWidthFlag = true;
								if (
									const_var.editAPIDataByResponse.data != undefined &&
									const_var.editAPIDataByResponse.data.request_data.building !== undefined &&
									(!isNaN(const_var.editAPIDataByResponse.data.request_data.building?.height) || const_var.editAPIDataByResponse.data.request_data.building?.height.includes("x") == false)
								) {
									chkFixedWidthFlag = false;
								}
								const_var.buildingHeightArray = [];
								let filterData = const_var.c_m_a[params.p_b_t].fixed_new_leg_width[0][params.p_w];
								Array.apply(null, { length: filterData.max_height + 1 })
									.map(Number.call, Number)
									.slice(filterData.min_height)
									.map((val, index) => {
										const_var.buildingHeightArray.push({ value: val, label: chkFixedWidthFlag == true ? val + " x " + (filterData.min_smaller_height + index) : val });
									});
								let chkHeight = const_var.buildingHeightArray.filter((data) => data.value == params.p_h);
								if (chkHeight.length == 0) {
									params.p_h = const_var.buildingHeightArray[0].value;
								}
							}
						}

						if (str == "w" && const_var.isForStandardBuilding == true && !const_var.b_o_J_1[params.p_b_t].includes("Free Standing") && !const_var.b_o_J_1[params.p_b_t].includes("RV Covers")) {
							if (from?.cmp != undefined && from.cmp == "popularSizes") {
								dispatch(getPricingData(undefined, from.val, from.str, "forLeanRoofReset"));
							}
						} else {
							if (!noApiCall) {
								dispatch(getPricingData(undefined, val, str, "forLeanRoofReset"));
							}
						}
						if (checkCustomDimension != undefined || str == "w" || str == "l") {
							const_var.UpdatedPriceData.roof_style_price_changed = true;
							const_var.UpdatedPriceData.roof_pitch_price_changed = true;
							const_var.UpdatedPriceData.height_price_changed = true;
						}
						if (str == "h" || (from != undefined && from.str == "h" && from?.cmp == "popularSizes")) {
							let heritageEditCase =
								const_var.crmSetting.is_Edit == true &&
								params.m_s_n == 153 &&
								(params.p_r_s == 1 || params.p_r_s == 2) &&
								const_var.editAPIDataByResponse != undefined &&
								const_var.editAPIDataByResponse.data != undefined;

							let lowerHeightOfFreeStanding =
								const_var.c_m_a[params.p_b_t] != undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width != undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length > 0
									? Math.floor(params.p_h - (params.p_w * params.p_r_p) / 12)
									: Math.round(params.p_h - (params.p_w * params.p_r_p) / 12);

							const_var.UpdatedPriceData.height_price_changed = true;
							const_var.UpdatedPriceData.roof_pitch_price_changed = true;
							const_var.UpdatedPriceData.roof_style_price_changed = true;

							if (
								params.singleSlope != true &&
								((const_var.crmSetting.is_Edit != true && params.m_s_n == 153 && (params.p_r_s == 2 || params.p_r_s == 1) && params.p_h > 10) || (heritageEditCase == true && params.p_h > 10))
							) {
								if (const_var.insulationPriceJson?.insulation_wall != undefined && Object.keys(const_var.insulationPriceJson.insulation_wall).length > 0) {
									const_var.insulationPriceJson.insulation_wall = {};
								}

								// ################### Handle full roof or full building case ######################
								if ((params.p_r_o == true || params.p_f_i == true) && params.add_left_lean != true && params.add_right_lean != true && params.add_front_lean != true && params.add_back_lean != true) {
									params.p_r_o = false;
									params.p_f_i = false;
									params.p_i_o = 0;
								}

								params.insulation.center.insulationId = 0;

								params.insulation.center.isCheked = false;

								params.insulation.center.showInsulationOptions = false;
								params.insulation.center.roofOnly = params.insulation.center.insulationId !== 0 ? true : false;
								params.insulation.center.fullBuilding = params.insulation.center.roofOnly ? false : params.insulation.center.fullBuilding;
								params.insulation.center.custom = params.insulation.center.roofOnly || params.insulation.center.fullBuilding ? false : params.insulation.center.custom;

								const_var.UpdatedPriceData.insulation_price_changed = true;
								const_var.UpdatedPriceData.custom_insulation_down_payment_rate = undefined;
								// ########### Front lean ##############

								if (params.add_front_lean == true && params.insulation["frontLean"] != undefined && params.m_s_n == 153 && (params.p_r_s == 1 || params.p_r_s == 2) && params.leanF_p_h > 10) {
									params.insulation["frontLean"].isCheked = false;
									params.insulation["frontLean"].insulationId = 0;

									params.insulation["frontLean"].showInsulationOptions = false;
									params.insulation["frontLean"].roofOnly = params.insulation["frontLean"].insulationId !== 0 ? true : false;
									params.insulation["frontLean"].fullBuilding = params.insulation["frontLean"].roofOnly ? false : params.insulation["frontLean"].fullBuilding;
									params.insulation["frontLean"].custom = params.insulation["frontLean"].roofOnly || params.insulation["frontLean"].fullBuilding ? false : params.insulation["frontLean"].custom;
								}

								// ########### Back lean ##############
								if (params.add_back_lean == true && params.insulation["backLean"] != undefined && params.m_s_n == 153 && (params.p_r_s == 1 || params.p_r_s == 2) && params.leanB_p_h > 10) {
									params.insulation["backLean"].isCheked = false;
									params.insulation["backLean"].insulationId = 0;

									params.insulation["backLean"].showInsulationOptions = false;
									params.insulation["backLean"].roofOnly = params.insulation["backLean"].insulationId !== 0 ? true : false;
									params.insulation["backLean"].fullBuilding = params.insulation["backLean"].roofOnly ? false : params.insulation["backLean"].fullBuilding;
									params.insulation["backLean"].custom = params.insulation["backLean"].roofOnly || params.insulation["backLean"].fullBuilding ? false : params.insulation["backLean"].custom;
								}

								// ########### Right lean ##############
								if (params.add_right_lean == true && params.insulation["rightLean"] != undefined && params.m_s_n == 153 && (params.p_r_s == 1 || params.p_r_s == 2) && params.leanR_p_h > 10) {
									params.insulation["rightLean"].isCheked = false;
									params.insulation["rightLean"].insulationId = 0;

									params.insulation["rightLean"].showInsulationOptions = false;
									params.insulation["rightLean"].roofOnly = params.insulation["rightLean"].insulationId !== 0 ? true : false;
									params.insulation["rightLean"].fullBuilding = params.insulation["rightLean"].roofOnly ? false : params.insulation["rightLean"].fullBuilding;
									params.insulation["rightLean"].custom = params.insulation["rightLean"].roofOnly || params.insulation["rightLean"].fullBuilding ? false : params.insulation["rightLean"].custom;
								}

								// ########### Left lean ##############

								if (params.add_left_lean == true && params.insulation["leftLean"] != undefined && params.m_s_n == 153 && (params.p_r_s == 1 || params.p_r_s == 2) && params.lean_p_h > 10) {
									params.insulation["leftLean"].isCheked = false;
									params.insulation["leftLean"].insulationId = 0;

									params.insulation["leftLean"].showInsulationOptions = false;
									params.insulation["leftLean"].roofOnly = params.insulation["leftLean"].insulationId !== 0 ? true : false;
									params.insulation["leftLean"].fullBuilding = params.insulation["leftLean"].roofOnly ? false : params.insulation["leftLean"].fullBuilding;
									params.insulation["leftLean"].custom = params.insulation["leftLean"].roofOnly || params.insulation["leftLean"].fullBuilding ? false : params.insulation["leftLean"].custom;
								}
							}

							// ################# Single Slope : Heritage manufacture ###############

							if (
								params.singleSlope == true &&
								((const_var.crmSetting.is_Edit != true && params.m_s_n == 153 && (params.p_r_s == 2 || params.p_r_s == 1) && lowerHeightOfFreeStanding > 10) ||
									(heritageEditCase == true && lowerHeightOfFreeStanding > 10))
							) {
								// params.p_i_o = 0;
								if (const_var.insulationPriceJson.insulation_wall && Object.keys(const_var.insulationPriceJson.insulation_wall).length > 0) {
									const_var.insulationPriceJson.insulation_wall = {};
								}

								// ################### Handle full roof or full building case Fot free standing ######################
								if (params.p_r_o == true || params.p_f_i == true) {
									params.p_r_o = false;
									params.p_f_i = false;
									params.p_i_o = 0;
								}
								params.insulation.center.insulationId = 0;
								params.insulation.center.isCheked = false;

								params.insulation.center.showInsulationOptions = false;
								params.insulation.center.roofOnly = params.insulation.center.insulationId !== 0 ? true : false;
								params.insulation.center.fullBuilding = params.insulation.center.roofOnly ? false : params.insulation.center.fullBuilding;
								params.insulation.center.custom = params.insulation.center.roofOnly || params.insulation.center.fullBuilding ? false : params.insulation.center.custom;

								const_var.UpdatedPriceData.custom_insulation_down_payment_rate = undefined;
							}
						}
						const_var.UpdatedPriceData.insulation_price_changed = true;
					}
				});
			} else {
				batch(() => {
					dispatch({
						type: "CHANGEDIMENSION",
						value: val,
						str: str,
						valueToSet: valueToSet
					});
					const checkLegs = str == "leanF_h" || str == "lean_h" || str == "leanR_h" || str == "leanB_h" ? undefined : "checkLegs";
					if ((leftFront || rightFront || leftBack || rightBack) && (str == "leanF_l" || str == "lean_l" || str == "leanR_l" || str == "leanB_l")) {
						if (checkLean == "left") {
							utils.update26GAUpgradePrice("left");
							dispatch(getPricingDataForLeanto(val, "addLeftLean", "", false, checkLegs));
						}
						if (checkLean == "right") {
							utils.update26GAUpgradePrice("right");
							dispatch(getPricingDataForLeanto(val, "addRightLean", "", false, checkLegs));
						}
						if (checkLean == "front") {
							utils.update26GAUpgradePrice("front");
							dispatch(getPricingDataForLeanto(val, "addFrontLean", "", false, checkLegs));
						}
						if (checkLean == "back") {
							utils.update26GAUpgradePrice("back");
							dispatch(getPricingDataForLeanto(val, "addBackLean", "", false, checkLegs));
						}
					} else {
						let heritageEditCase =
							const_var.crmSetting.is_Edit == true &&
							params.m_s_n == 153 &&
							(params.p_r_s == 1 || params.p_r_s == 2) &&
							const_var.editAPIDataByResponse != undefined &&
							const_var.editAPIDataByResponse.data != undefined;

						if (checkLean == "left") {
							utils.update26GAUpgradePrice("left");
							dispatch(getPricingDataForLeanto(val, "addLeftLean", "", false, checkLegs));
							// ########### Left lean : heritage manufacture ##############

							if (
								(const_var.crmSetting.is_Edit != true &&
									params.add_left_lean == true &&
									params.insulation["leftLean"] != undefined &&
									params.m_s_n == 153 &&
									(params.p_r_s == 1 || params.p_r_s == 2) &&
									params.lean_p_h > 10) ||
								(heritageEditCase == true && params.lean_p_h > 10)
							) {
								params.insulation["leftLean"].isCheked = false;
								params.insulation["leftLean"].insulationId = 0;

								params.insulation["leftLean"].showInsulationOptions = false;
								params.insulation["leftLean"].roofOnly = params.insulation["leftLean"].insulationId !== 0 ? true : false;
								params.insulation["leftLean"].fullBuilding = params.insulation["leftLean"].roofOnly ? false : params.insulation["leftLean"].fullBuilding;
								params.insulation["leftLean"].custom = params.insulation["leftLean"].roofOnly || params.insulation["leftLean"].fullBuilding ? false : params.insulation["leftLean"].custom;
							}
						}
						if (checkLean == "right") {
							utils.update26GAUpgradePrice("right");
							dispatch(getPricingDataForLeanto(val, "addRightLean", "", false, checkLegs));
							// ########### Right lean : heritage manufacture ##############
							if (
								(const_var.crmSetting.is_Edit != true &&
									params.add_right_lean == true &&
									params.insulation["rightLean"] != undefined &&
									params.m_s_n == 153 &&
									(params.p_r_s == 1 || params.p_r_s == 2) &&
									params.leanR_p_h > 10) ||
								(heritageEditCase == true && params.leanR_p_h > 10)
							) {
								params.insulation["rightLean"].isCheked = false;
								params.insulation["rightLean"].insulationId = 0;

								params.insulation["rightLean"].showInsulationOptions = false;
								params.insulation["rightLean"].roofOnly = params.insulation["rightLean"].insulationId !== 0 ? true : false;
								params.insulation["rightLean"].fullBuilding = params.insulation["rightLean"].roofOnly ? false : params.insulation["rightLean"].fullBuilding;
								params.insulation["rightLean"].custom = params.insulation["rightLean"].roofOnly || params.insulation["rightLean"].fullBuilding ? false : params.insulation["rightLean"].custom;
							}
						}
						if (checkLean == "front") {
							utils.update26GAUpgradePrice("front");
							dispatch(getPricingDataForLeanto(val, "addFrontLean", "", false, checkLegs));
							// ########### Front lean : heritage manufacture ##############

							if (
								(const_var.crmSetting.is_Edit != true &&
									params.add_front_lean == true &&
									params.insulation["frontLean"] != undefined &&
									params.m_s_n == 153 &&
									(params.p_r_s == 1 || params.p_r_s == 2) &&
									params.leanF_p_h > 10) ||
								(heritageEditCase == true && params.leanF_p_h > 10)
							) {
								params.insulation["frontLean"].isCheked = false;
								params.insulation["frontLean"].insulationId = 0;

								params.insulation["frontLean"].showInsulationOptions = false;
								params.insulation["frontLean"].roofOnly = params.insulation["frontLean"].insulationId !== 0 ? true : false;
								params.insulation["frontLean"].fullBuilding = params.insulation["frontLean"].roofOnly ? false : params.insulation["frontLean"].fullBuilding;
								params.insulation["frontLean"].custom = params.insulation["frontLean"].roofOnly || params.insulation["frontLean"].fullBuilding ? false : params.insulation["frontLean"].custom;
							}
						}
						if (checkLean == "back") {
							utils.update26GAUpgradePrice("back");
							dispatch(getPricingDataForLeanto(val, "addBackLean", "", false, checkLegs));
							// ########### Back lean : heritage manufacture ##############
							if (
								(const_var.crmSetting.is_Edit != true &&
									params.add_back_lean == true &&
									params.insulation["backLean"] != undefined &&
									params.m_s_n == 153 &&
									(params.p_r_s == 1 || params.p_r_s == 2) &&
									params.leanB_p_h > 10) ||
								(heritageEditCase == true && params.leanB_p_h > 10)
							) {
								params.insulation["backLean"].isCheked = false;
								params.insulation["backLean"].insulationId = 0;

								params.insulation["backLean"].showInsulationOptions = false;
								params.insulation["backLean"].roofOnly = params.insulation["backLean"].insulationId !== 0 ? true : false;
								params.insulation["backLean"].fullBuilding = params.insulation["backLean"].roofOnly ? false : params.insulation["backLean"].fullBuilding;
								params.insulation["backLean"].custom = params.insulation["backLean"].roofOnly || params.insulation["backLean"].fullBuilding ? false : params.insulation["backLean"].custom;
							}
						}
					}
				});
			}
			params.preAction = {};
		}
	};
}
